import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';

const styles = css`
  padding: 20px 0;
  background-color: ${colors.color3};
  @media (min-width: 480px) {
    padding: 40px 0;
  }
  .row {
    flex-direction: column-reverse;
    @media (min-width: 1200px) {
      flex-direction: row;
    }
  }
  h2 {
    font:300 24px/30px ${typography.SansSerif};
    color:${colors.color1};
    text-transform:capitalize;
    @media (min-width: 480px) {
      font:300 30px/43px ${typography.SansSerif};
    }

    &:after {
      content:'';
      width:100px;
      height:2px;
      background-color:${colors.color2};
      display:block;
      margin:20px 0 20px 0;
      @media (min-width: 480px) {
        margin:30px 0 30px 0;
      }
    }
  }
  p {
    font:300 16px/30px ${typography.SansSerif};
    @media (min-width: 480px) {
      font:300 18px/36px ${typography.SansSerif};
    }
  }
  .PageIntroBanner_body {
    font: 300 18px/36px 'museo-sans',sans-serif;
  }
  .PageIntroBanner_image {
    display: flex;
    background-size: cover;
    background-position: center center;
    width: 100%;
    padding-top: 56.25%;
    margin: 0 0 15px 0;
    border: 1px solid #ccc;
    margin: 0 0 20px 0;
    max-height: 500px;
    @media (min-width: 991px) {
      margin: 0 0 40px 0;
    }
    @media (min-width: 1199px) {
      margin: 0;
      min-height: 300px;
    }
  }
`;

function PageIntroBanner({ heading, body, image, link, label, internalLink }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <h2>{heading}</h2>
            <div className="PageIntroBanner_body" dangerouslySetInnerHTML={SanitizeHtml(body)} />
            {
              label &&
              <a href={link} target="_blank" rel="noopener noreferrer">
                <div className="btn">{label}</div>
              </a>
            }
            {
              internalLink &&
              <a href={internalLink}>
                <div className="btn">{label}</div>
              </a>
            }
          </div>
          <div className="col-xl-6 d-flex">
            <div
              className="PageIntroBanner_image"
              style={{ backgroundImage: `url(${buildThumbnailUrl(image, { width: 1200, height: 1200, preserve: true })})` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

PageIntroBanner.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
  internalLink: PropTypes.string,
  label: PropTypes.string,
};

PageIntroBanner.defaultProps = {
  heading: undefined,
  body: undefined,
  image: undefined,
  link: undefined,
  internalLink: undefined,
  label: undefined,
};

export default PageIntroBanner;



// WEBPACK FOOTER //
// ./src/components/PageIntroBanner.js